export const DEFAULT_DEPARTURE_CITY = 'New Delhi';
export const LISTING_PAGE_NAME = 'listing';
